<template>
  <div class="kd-range-slider">
    <!--
        Both, "change" and "input" events are used for IE11 compatibility.
        Only "input" is needed for modern browsers.
      -->
    <input
      type="range"
      class="kd-range-slider__input"
      v-model="value"
      :step="step"
      :min="min"
      :max="max"
      @input="onChange"
      @change="onChange"
    >
    <div v-if="showLabels" class="kd-range-slider__labels">
      <div class="kd-range-slider__label kd-range-slider__label--left">{{ labelLeft }}</div>
      <div class="kd-range-slider__label kd-range-slider__label--center">{{ labelCenter }}</div>
      <div class="kd-range-slider__label kd-range-slider__label--right">{{ labelRight }}</div>
    </div>
  </div>
</template>

<script>
import * as log from 'loglevel';

export default {
  props: {
    initialValue: Number,
    step: Number,
    min: Number,
    max: Number,
    showLabels: {
      type: Boolean,
      default: false,
    },
    labelLeft: {
      type: String,
      default: '',
    },
    labelCenter: {
      type: String,
      default: '',
    },
    labelRight: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: 0,
    };
  },
  methods: {
    onChange(ev) {
      this.$emit('change', ev.target.value);
    },
  },
  watch: {
    initialValue(newValue) {
      this.value = newValue;
    },
    // initialValue: {
    //   handler(newValue) {
    //     this.value = newValue;
    //     log.debug('Slider value prop changed: ', newValue);
    //   },
    //   deep: true,
    // },
  },
  mounted() {
    this.value = this.initialValue;
  },
};
</script>

<style lang="scss">
.kd-range-slider__labels {
  position: relative;
  min-height: 11px; // same as font size of labels
}

.kd-range-slider__label {
  position: absolute;
  font-size: 11px;
  color: #929292;
  font-style: italic;

  &--left {
    left: 0;
    display: inline-block;
  }
  &--center {
    width: 100%;
    text-align: center;
  }
  &--right {
    right: 0;
    display: inline-block;
  }
}

/* The slider + browser specific overrides */

@mixin track() {
  background-color: red;
  border-radius: 8px;
 }

.kd-range-slider__input {
  &::-webkit-slider-runnable-track { @include track }
  &::-moz-range-track { @include track }
  &::-ms-track { @include track }
}

// $track-w: 200px; // 12.5em;
$track-w: 204px;
$track-h: 4px; // .25em;
$thumb-d: 19px; // 1.2em;
$track-c: #DDDDDD;
$dist: $track-w - $thumb-d;

@mixin track() {
    box-sizing: border-box;
    border: none;
    width: $track-w;
    height: $track-h;
    background: $track-c;
}

@mixin thumb() {
    box-sizing: border-box;
    border: none;
    background: white;
    border: 1px solid #B1B1B1;
    width: $thumb-d;
    height: $thumb-d;
    border-radius: 50%;
    cursor: grab;

    &:active {
      cursor: grabbing;
    }
}

// .wrap {
//     display: flex;
//     align-items: center;
//     position: relative;
//     width: $track-w; height: 3.5*$thumb-d;
//     font: 1em/1 arial, sans-serif
// }

.kd-range-slider__input {
  &, &::-webkit-slider-thumb {
    -webkit-appearance: none
  }

  flex: 1;
  margin: 0;
  padding: 0;
  min-height: $thumb-d;
  width: 204px;
  background: transparent;
  font: inherit;

  &::-webkit-slider-runnable-track {
    @include track()
  }
  &::-moz-range-track { @include track }
  &::-ms-track { @include track }

  &::-webkit-slider-thumb {
    margin-top: .5*($track-h - $thumb-d);
    @include thumb
  }
  &::-moz-range-thumb { @include thumb }
  &::-ms-thumb {
    margin-top: 0;
    @include thumb
  }

  &::-ms-tooltip { display: none }
  ~ output {
    display: none;
  }
}
</style>
